import api from './api';

export const sendMessage = async (message, history = []) => {
  try {
    const response = await api.post('/chat', { message, history });
    return response.data.response;
  } catch (error) {
    console.error('Error sending chat message:', error);
    throw error;
  }
};
